<template>
    <div class="list-changes">
        <v-btn
            class="btn-back"
            :to="{name: 'hotelList'}"
        >
            <v-icon>mdi-arrow-left</v-icon> Voltar
        </v-btn>
        <v-container class="list-changes-container">
            <list-changes-hotel />
        </v-container>
    </div>
</template>

<script>
import ListChangesHotel from "../../components/Hotel/ListChangesHotel.vue";
export default {
    name: "HotelListChanges",
    components: {ListChangesHotel},
}
</script>

<style scoped>
.list-changes {
    position: relative;
    background-color: #f0f0f0;
    height: 100%;
}

.list-changes-container {
     padding-top: 80px;
     width: 90%;
}

.btn-back {
    position: absolute;
    top: 20px;
    left: 20px;
}
</style>
